import React from 'react';

import BaseComponent from 'src/components/BaseComponent';
import { AvatarImages } from './components';
import { lang } from 'src/helpers';
import { MCButton, SelectField, TextAreaField, TextField } from '../basic';
import constants from 'src/constants';
import DefaultPdfImg from 'src/assets/images/default-pdf-img.png';
import LANG_CONST from 'src/helpers/lang/const';
import { EmailPhoneSection, FormRow } from '../Form';
import { AlertBox } from '../alert';
import { remCss } from 'src/helpers';

const apiStateId = 'updateClinic';

class ClinicInput extends BaseComponent {
  componentDidMount() {
    const { model } = this.props;
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    const { model } = this.props;
    model.unsubscribe(this.subscription);
  }

  render() {
    const {
      model,
      emailReadonly = false,
      phoneReadonly = false,
      imagesEnable = false,
      certificate = false
    } = this.props;
    const { handleChangeProfile, handleBlur } = model;
    const { invalid, ...createState } = model.getApiState(apiStateId);

    if (createState.error === 'URLNAME_TAKEN') {
      invalid['username'] = createState.errorMessage;
    }

    if (createState.error === 'EMAIL_TAKEN') {
      invalid['email'] = createState.errorMessage;
    }

    return (
      <>
        <AvatarImages
          avatar={model.input('avatar')}
          images={model.input('images')}
          imagesEnable={imagesEnable}
          invalid={{}}
          onAvatarChange={(v) => {
            model.resetApiState(apiStateId);
            model.handleChangeAvatar(v);
          }}
          onImagesChange={(v) => {
            model.resetApiState(apiStateId);
            handleChangeProfile('images', v);
          }}
        />
        {invalid?.avatar && (
          <AlertBox
            message={invalid?.avatar}
            onClose={() => {
              model.setInvalidApi(apiStateId, { ...invalid, avatar: null });
            }}
          />
        )}
        <div className={'mc-value-620'}>{lang.t('Clinic information')}</div>
        <div className={'mc-flex-20-col'}>
          <FormRow>
            <TextField
              template={6}
              label={'Username'}
              name={'username'}
              value={model.input('username')}
              onChange={handleChangeProfile}
              onBlur={handleBlur}
              invalid={invalid}
            />
            <TextField
              template={6}
              label={'Clinic Name'}
              name={'name'}
              value={model.input('name')}
              onChange={handleChangeProfile}
              onBlur={handleBlur}
              invalid={invalid}
            />
          </FormRow>

          <EmailPhoneSection
            defaultCountryName={model.state.tempCountryAddress}
            emailReadonly={emailReadonly}
            phoneReadonly={phoneReadonly}
            email={model.input('email')}
            handleChangeProfile={handleChangeProfile}
            handleBlur={handleBlur}
            navigate={this.navigate}
            phoneNumber={model.input('phoneNumber').toString()}
          />
          <FormRow>
            <SelectField
              template={6}
              width={`calc(50% - ${remCss(10)}px)`}
              placeholder={'Enter keyword here'}
              label={'Speciality'}
              isMultipleSpecial={true}
              isClearable={false}
              options={constants.general.specialist}
              name={'specialist'}
              value={model.input('specialist')}
              onChange={handleChangeProfile}
              invalid={invalid}
            />
          </FormRow>
          <FormRow>
            <TextAreaField
              template={6}
              rows={4}
              label={'Description'}
              name={'description'}
              placeholder={''}
              value={model.input('description')}
              onChange={handleChangeProfile}
              onBlur={handleBlur}
              invalid={invalid}
            />
          </FormRow>
        </div>
        {certificate && (
          <div className={'mc-flex-col'}>
            <div className={'mc-label-416'}>{lang.t('Upload Certificate')}</div>
            <TextField
              template={6}
              multiple={true}
              files={model.state.certificateFiles}
              type={'file'}
              name={'certificateFiles'}
              onChange={(n, v, e) => {
                if (e.target.files.length > 0) {
                  handleChangeProfile(n, [...e.target.files]);
                }
              }}
              onBlur={handleBlur}
              invalid={invalid}
              accept={'application/pdf, image/*'}
              thumbnail={DefaultPdfImg}
            />
          </div>
        )}
        {/*<div className={'mc-value-620'}>{lang.t('Treatments')}</div>*/}
        {/*<div className={'mc-flex-col'}>*/}
        {/*  <Treatment*/}
        {/*    treatments={model.input('treatments')}*/}
        {/*    defaultTreatments={model.defaultTreatments}*/}
        {/*    handleChange={handleChangeProfile}*/}
        {/*    handleBlur={handleBlur}*/}
        {/*    invalid={invalid}*/}
        {/*  />*/}
        {/*</div>*/}
        <div className={'mc-flex-20'}>
          <MCButton
            label={LANG_CONST.buttons.delete_account}
            medium
            radius
            senary
            light
            onClick={() => model.emit('deleteAccount')}
          />
        </div>
      </>
    );
  }
}

export default ClinicInput;
